import React, { useEffect, useState } from "react";
import { CreatedBy } from "./PublicViewRender";
import CroppedImageFromFile from "../../../../components/formComponents/CroppedImage";
import ImgOptimized from "../../../../components/ImgOptimized";
import { getImageUrls, getBase64ImageFromUrl } from "../../../../utils/helpers";
import AbLogo from "../../../../assets/logo192.png";
import classNames from "classnames";

const LayoutSlide = ({ layout, viewData, index, isPdf, isPdfContent }) => {
  console.log({ layout, index, isPdf });

  const [base64FloorMap, setBase64FloorMap] = useState("");
  const isPdfMode = isPdf || isPdfContent;

  useEffect(() => {
    if (
      isPdfMode &&
      (Array.isArray(layout?.floorMap)
        ? layout?.floorMap?.[0]
        : layout?.floorMap)
    ) {
      const floorMapUrl = getImageUrls(
        [
          Array.isArray(layout?.floorMap)
            ? layout?.floorMap?.[0]
            : layout?.floorMap,
        ],
        true,
        true,
      )?.[0];
      // console.log({floorMapUrl})
      if (floorMapUrl) {
        getBase64ImageFromUrl(floorMapUrl).then((base64) => {
          setBase64FloorMap(base64);
        });
      }
    }
  }, [isPdfMode, layout?.floorMap]);

  const floorMapSrc =
    isPdfMode && base64FloorMap
      ? base64FloorMap
      : getImageUrls(
          [
            Array.isArray(layout?.floorMap)
              ? layout?.floorMap?.[0]
              : layout?.floorMap,
          ],
          true,
          true,
        )?.[0];

  return (
    <div className="w-full h-full mx-1 bg-white">
      <div className="overflow-hidden flex items-end justify-between h-full w-full pb-2 relative">
        <ImgOptimized
          src={AbLogo}
          alt="AirBrick Logo"
          className="w-auto max-h-10 absolute top-2 left-2"
        />

        <div className="flex-1 flex items-end h-full  relative">
          <ImgOptimized
            src={floorMapSrc}
            alt="Floor Map"
            className="max-h-[85.5%] max-w-full w-full h-full object-contain"
            onLoad={(e) =>
              console.log(e.target.height, e.target.width, "IMAGE LOADED")
            }
          />
          {layout?.selection1?.areaData && !isPdf && (
            <div className="w-18 h-18 md:w-24 md:h-24 xl:w-[10vw] xl:h-[10vw] absolute bottom-4 left-5 border border-gray-300 rounded-full overflow-hidden">
              <CroppedImageFromFile
                imageFile={floorMapSrc}
                areaData={layout?.selection1?.areaData}
                position={layout?.selection1?.position}
                isPublicView={isPdf}
                radius={layout?.selection1?.radius}
              />
            </div>
          )}

          {layout?.selection2?.areaData && !isPdf && (
            <div className="w-18 h-18 md:w-24 md:h-24 xl:w-[10vw] xl:h-[10vw] absolute bottom-4 right-5 border border-gray-300 rounded-full overflow-hidden">
              <CroppedImageFromFile
                imageFile={floorMapSrc}
                areaData={layout?.selection2?.areaData}
                position={layout?.selection2?.position}
                isPublicView={isPdf}
                radius={layout?.selection2?.radius}
              />
            </div>
          )}

          {layout?.selection3?.areaData && !isPdf && (
            <div className="w-18 h-18 md:w-24 md:h-24 xl:w-[10vw] xl:h-[10vw] absolute top-1/3 left-5 border border-gray-300 rounded-full overflow-hidden">
              <CroppedImageFromFile
                imageFile={floorMapSrc}
                areaData={layout?.selection3?.areaData}
                position={layout?.selection3?.position}
                isPublicView={isPdf}
                radius={layout?.selection3?.radius}
              />
            </div>
          )}

          {layout?.selection4?.areaData && !isPdf && (
            <div className="w-18 h-18 md:w-24 md:h-24 xl:w-[10vw] xl:h-[10vw] absolute top-1/3 right-5 border border-gray-300 rounded-full overflow-hidden">
              <CroppedImageFromFile
                imageFile={floorMapSrc}
                areaData={layout?.selection4?.areaData}
                position={layout?.selection4?.position}
                isPublicView={isPdf}
                radius={layout?.selection4?.radius}
              />
            </div>
          )}
        </div>
        <div className="absolute top-1 right-3 px-2 py-1 rounded-full border-2 border-teal-600 text-teal-600 font-bold">
          <span
            className={classNames(isPdf ? "relative bottom-2 text-xs" : "")}
          >
            {" "}
            Option {index}
          </span>
        </div>

        {/* Legend Table */}
        {layout?.legend &&
          Array.isArray(layout?.legend) &&
          layout.legend.length > 0 &&
          !!layout.legend?.[0]?.key && (
            <div className="max-w-60 h-full flex flex-col pt-16 justify-start pr-0">
              <div className="border border-black text-[10px]">
                {/* Header */}
                <div className="bg-white border-b border-black">
                  <h2 className="text-center text-xs font-semibold py-0.5">
                    LEGEND
                  </h2>
                </div>

                {/* Column Headers */}
                <div className="flex border-b border-black bg-white">
                  <div className="w-10 border-r border-black px-1 py-0.5 text-center font-semibold">
                    SN
                  </div>
                  <div className="flex-1 border-r border-black px-1 py-0.5 text-center font-semibold">
                    Area
                  </div>
                  <div className="w-16 px-1 py-0.5 text-center font-semibold">
                    Achieved
                  </div>
                </div>

                {/* Table Rows */}
                <div className="bg-white">
                  {layout.legend.map((item, index) => (
                    <div
                      key={index}
                      className={`flex ${
                        index !== layout.legend.length - 1
                          ? "border-b border-black"
                          : ""
                      }`}
                    >
                      <div className="w-10 border-r border-black px-1 py-0.5 text-center text-[10px]">
                        {String(index + 1).padStart(2, "0")}
                      </div>
                      <div className="flex-1 border-r border-black px-1 py-0.5 text-[10px] uppercase">
                        {item.key}
                      </div>
                      <div className="w-16 px-1 py-0.5 text-center text-[10px]">
                        {item.value}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}

        {/* <CreatedBy
          username={viewData?.username}
          date={viewData?.createdAt}
          isPdf={false}
          className={ "bottom-0 -left-2"}
        /> */}
      </div>
    </div>
  );
};

export default LayoutSlide;
